import React from 'react'
import classes from './DownloadFileItem.scss'

import { approxFormatBinaryNumber } from 'cityads-v3/utils/textUtils'
import GetAppIcon from '@mui/icons-material/GetApp';
import Typography from '@mui/material/Typography'



type DownloadFileItemProps = {
  url: string,
  title: React.ReactNode,
  size: number,
}

export default function DownloadFileItem({ url, title, size }: DownloadFileItemProps): JSX.Element {
  const extension = url.match(/\.[^.]+$/)?.[0]

  return (
    <div className={classes.fileItem}>
      <div className={classes.linkContainer}>
        <a
          className = {classes.downloadLink}
          href      = {url}
        >
          <GetAppIcon className={classes.icon} color="action" />
          {title}
        </a>
      </div>
      <Typography component="div" className={classes.fileSize} color="textSecondary">
        {approxFormatBinaryNumber(size)} {extension ? `(${extension})` : null}
      </Typography>
    </div>
  )
}
